export const yacanConfig = {
  connection: {
    title: "Połączenie z YACAN",
    subtitle:
      "Połączenie konta YACAN pozwala zarządzać dostępem gości za pomocą zamków.",
    connected: "Konto połączone",
    notConnected: "Brak połączenia",
    info:
      "Po kliknięciu <b>Połącz z YACAN</b> otworzy się okno logowania i autoryzacji dostępu. Połączenie jest zapisywane dla całego konta i wykorzystywane we wszystkich obiektach.",
    connect: "Połącz z YACAN",
    waiting: "Oczekiwanie na autoryzację...",
    connectedTitle: "Konto YACAN połączone",
    authActive: "Autoryzacja aktywna",
    reauthorize: "Autoryzuj ponownie",
    reauthorizeTitle: "Autoryzuj ponownie",
    disconnect: "Rozłącz",
  },
  locks: {
    title: "Zamki w tym obiekcie",
    subtitle: "Wybierz zamki YACAN, które dotyczą <b>tego obiektu</b>.",
    selectedCount: "Wybrano: {count}",
    noneFound: "Nie znaleziono żadnych zamków na koncie YACAN.",
    refresh: "Odśwież",
    placeholder: "Wybierz zamki…",
    summary: "Wybrane zamki: {count}",
    empty: "Nie wybrano żadnego zamka",
    lockFallback: "Zamek {id}",
    save: "Zapisz zamki dla tego obiektu",
    saving: "Zapisywanie...",
  },
  assign: {
    title: "Przypisanie (PMS)",
    subtitle: "Przypisz każdy zamek do <b>drzwi głównych</b>, <b>jednostki</b> lub <b>bramy</b>.",
    assignedCount: "Przypisano: {count}",
    info:
      "W przypadku YACAN <b>dostępem gości zarządza YACAN</b> na podstawie rezerwacji: tutaj nie są generowane żadne kody PIN. Po potwierdzeniu rezerwacja synchronizuje się automatycznie z YACAN.",
    lockFallback: "Zamek {id}",
    assignmentLabel: "Przypisanie",
    typeNone: "Nieprzypisany",
    typeCommon: "Drzwi główne (wspólne)",
    typeUnit: "Drzwi apartamentu",
    typeGate: "Brama / Garaż",
    unitLabel: "Jednostka / Obiekt",
    unitPlaceholder: "Wybierz jednostkę",
    unitFallback: "Jednostka {id}",
    save: "Zapisz przypisanie",
    saving: "Zapisywanie...",
  },
  msg: {
    connectStartError: "Nie udało się rozpocząć połączenia z YACAN",
    popupBlocked: "Aby połączyć się z YACAN, należy zezwolić na wyskakujące okna.",
    connectError: "Błąd połączenia z YACAN",
    connectSuccess: "Konto YACAN zostało połączone",
    connectFailed: "Nie udało się połączyć z YACAN",
    disconnectConfirm:
      "Rozłączyć konto YACAN? Rezerwacje przestaną się synchronizować z YACAN.",
    disconnectSuccess: "Konto YACAN zostało rozłączone",
    disconnectError: "Nie udało się rozłączyć",
    locksLoadError: "Nie udało się wczytać zamków",
    locksLoadError2: "Błąd podczas wczytywania zamków YACAN",
    selectAtLeastOne: "Należy wybrać co najmniej jeden zamek.",
    lockDefaultName: "Zamek YACAN",
    locksSaved: "Zamki zostały zapisane dla tego obiektu",
    locksSaveError: "Nie udało się zapisać zamków",
    saveError: "Błąd podczas zapisywania",
    selectUnitForApartment: "Należy wybrać jednostkę dla zamków typu „Drzwi apartamentu”.",
    assignSaved: "Przypisanie zostało zapisane",
    assignSaveError: "Nie udało się zapisać przypisania",
    assignSaveError2: "Błąd podczas zapisywania przypisania",
  },
};
